import React, { useState, useEffect } from 'react';
import { Container, Box, Typography } from '@mui/material';
import axios from 'axios';
import Navbar from './Navbar';
import Footer from './Footer';
import HomePageFilters from './filters/HomePageFilters';
import ApartmentListing from './filters/ApartmentListing';
import AIAgentSearch from './ai_search/AIAgentSearch';
import { searchApartments } from './google_api/googleSearchService';

const ApartmentsPage = () => {
  const [apartments, setApartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [aiResults, setAiResults] = useState([]);
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError] = useState(null);
  const [appliedFilters, setAppliedFilters] = useState({});

  useEffect(() => {
    fetchApartments();
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.adsbygoogle) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (err) {
        // Silent fail for AdSense errors
      }
    }
  }, []);

  const fetchApartments = async (filterParams = {}) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/public-apartments/`, {
        params: filterParams,
      });
      const normalizedApartments = response.data.map(apartment => ({
        ...apartment,
        photoURL: Array.isArray(apartment.photoURL) ? apartment.photoURL : []
      }));
      setApartments(normalizedApartments);
    } catch (error) {
      setError('Error fetching apartments');
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async (newFilters) => {
    // Store the applied filters
    setAppliedFilters(newFilters);

    // Fetch RentLord apartments with coordinates
    fetchApartments(newFilters);

    // Fetch AI results with only place_description
    setAiLoading(true);
    setAiError(null);
    try {
      // Extract place_description from the selected location
      const aiFilters = {
        place_description: newFilters.place_description,
        min_square_footage: newFilters.min_square_footage,
        max_square_footage: newFilters.max_square_footage,
        rooms: newFilters.rooms
      };
      const results = await searchApartments(aiFilters);
      // console.log('Google Search Results:', {
      //   filters: aiFilters,
      //   results: results,
      //   snippets: results.map(result => ({
      //     title: result.title,
      //     snippet: result.snippet,
      //     link: result.link,
      //     position: result.position
      //   }))
      // });
      setAiResults(results);
    } catch (err) {
      console.error('Failed to search for apartments:', err);
      setAiError('Failed to search for apartments. Please try again.');
    } finally {
      setAiLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Container sx={{ flexGrow: 1, py: 2, flex: '1 0 auto' }}>
        <HomePageFilters onSearch={handleSearch} />
        
        {/* AI Search Results Section */}
        <Box sx={{ mt: 4, mb: 4 }}>
          <Typography variant="h6" sx={{ mb: 3, color: 'primary.main' }}>
            AI-Powered Results
          </Typography>
          {aiLoading && <p>Searching with AI...</p>}
          {aiError && <p style={{ color: 'red' }}>{aiError}</p>}
          <AIAgentSearch results={aiResults} filters={appliedFilters} />
        </Box>

        {/* RentLord Results Section */}
        <Box sx={{ mt: 4, mb: 4 }}>
          <Typography variant="h6" sx={{ mb: 3, color: 'primary.main' }}>
            RentLord Results
          </Typography>
          {loading && <p>Loading apartments...</p>}
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <ApartmentListing apartments={apartments} loading={loading} error={error} />
        </Box>
      </Container>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        margin: '25px 0',
        width: '100%',
        minHeight: '100px'
      }}>
        <ins
          className="adsbygoogle"
          style={{ 
            display: 'block',
            width: '100%',
            minWidth: '300px',
            maxWidth: '1200px',
            height: '100px'
          }}
          data-ad-client="ca-pub-4558262338290493"
          data-ad-slot="9665979324"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
      <Footer />
    </div>
  );
};

export default ApartmentsPage;